import React, { createContext, useEffect, useState } from "react";
import axiosInstance from "../utils/axios-instance";

export const AngelChatContext = createContext(undefined);

const AngelChatProvider = ({ children }) => {
  const [conversations, setConversations] = useState({
    totalCount: 0,
    data: [],
  });
  const [currentConversation, setCurrentConversation] = useState(null);

  // ----------------------------------------------- FIND CONVERSATIONS --------------------------------------------

  useEffect(() => {
    const findConversations = async () => {
      try {
        const res = await axiosInstance("/resume-chat/find/conversations");
        setConversations(res.data);
      } catch (error) {
        // console.log(error);
      }
    };

    findConversations();
  }, []);

  // ------------------------------------------------ SELECT CONVERSATION -----------------------------------------
  const handleSelectConversation = (data) => {
    setCurrentConversation(data);
  };

  return (
    <AngelChatContext.Provider
      value={{ conversations, currentConversation, handleSelectConversation }}
    >
      {children}
    </AngelChatContext.Provider>
  );
};

export default AngelChatProvider;
